import { TOneItemCallback } from 'HttpRequests'
import React, { useCallback } from 'react'

interface IPositiveNumInputProps {
  value: number | null
  maxValue?: number
  onChange?: TOneItemCallback<number | null>
  disabled?: boolean
  onEntered?: TOneItemCallback<number | null>
  className?: string
  style?: React.CSSProperties
}

const PositiveNumInput: React.FC<IPositiveNumInputProps> = ({
  value,
  maxValue,
  onChange,
  onEntered,
  disabled,
  className,
  style,
}) => {
  const handleChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      let value_ = event.target.value
      if (value_ === '') {
        onChange && onChange(null)
      } else {
        let value_int = parseInt(value_)
        if (!value_int || value_int < 0) {
          value_int = 0
        } else if (maxValue && value_int > maxValue) {
          value_int = maxValue
        }
        onChange && onChange(value_int)
      }
    },
    [maxValue, onChange]
  )

  const handleKeyDown = useCallback(
    (event: React.KeyboardEvent<HTMLInputElement>) => {
      if (onEntered && event.key === 'Enter') onEntered(value)
    },
    [onEntered, value]
  )

  const handleBlur = useCallback(() => {
    if (onEntered) onEntered(value)
  }, [onEntered, value])

  return (
    <input
      className={'form-control ' + className || ''}
      value={value ? value.toString() : ''}
      type='text'
      onChange={handleChange}
      onKeyDown={handleKeyDown}
      onBlur={handleBlur}
      disabled={disabled}
      style={style}
    />
  )
}
export default PositiveNumInput
